<template>
	<div class="section">
		<div class="container breathe">
			<div class="columns">
				<div class="column is-6 yellow-right-border" style="margin-left: 20px">
					<h2>Free access</h2>
					<div style="margin-right: 50px">
						<b-field>
							<b-input v-model="FreeName" placeholder="Name"></b-input>
						</b-field>
						<b-field>
							<b-input v-model="FreeCompany" placeholder="Company"></b-input>
						</b-field>
						<b-field>
							<b-input type="email" v-model="FreeEmail" placeholder="Email address"></b-input>
						</b-field>
					</div>
					<br />
					<b-checkbox v-model="AgreeToTC"></b-checkbox>
					Agree to
					<a @click="cardModal">Terms and Conditions</a>
					<br />
					<br />
					<b-button
						@keydown.native="catch_free_enter($event)"
						class="is-primary"
						v-bind:class="{ 'is-loading': loading == true }"
						icon-right="arrow-right"
						@click="getFreeAccess">
						Get Access
					</b-button>
				</div>
				<div class="column is-6" style="margin-left: 20px; padding-right: 50px">
					<div class="title is-2">Credentialed user login</div>
					<b-input
						@keydown.native="catch_Enter($event)"
						type="email"
						v-model="CredEmail"
						placeholder="Email address"></b-input>
					<br />
					<b-input
						@keydown.native="catch_Enter($event)"
						type="password"
						v-model="Password"
						placeholder="Password"></b-input>
					<br />
					<div class="level">
						<div class="level-left">
							<div class="level-item">
								<router-link to="/forgotPassword">Forgot your password?</router-link>
							</div>
						</div>
						<div class="level-right">
							<div class="level-item">
								<b-button
									class="is-primary"
									v-bind:class="{ 'is-loading': loggingIn == true }"
									icon-right="arrow-right"
									@click="login">
									Login
								</b-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import termsAndConditions from "@/components/modals/termsAndConditions.vue";
	export default {
		name: "login",
		data() {
			return {
				FreeEmail: "",
				FreeName: "",
				FreeCompany: "",
				AgreeToTC: false,
				CredEmail: "",
				Password: "",
				loading: false,
				loggingIn: false
			};
		},
		created() {
			if (localStorage.getItem("CTC_USER") != null) {
				this.$router.push("/index");
			}
		},
		methods: {
			catch_free_enter(e) {
				if (e.keyCode === 13 && !this.loading && this.AgreeToTC == true) {
					this.getFreeAccess();
				}
			},
			catch_Enter(e) {
				if (e.keyCode === 13 && !this.loading) {
					this.login();
				}
			},
			cardModal() {
				this.$buefy.modal.open({
					parent: this,
					component: termsAndConditions,
					hasModalCard: true
				});
			},
			getFreeAccess() {
				this.loading = true;
				if (this.FreeEmail && this.FreeName && this.FreeCompany) {
					this.$store
						.dispatch("freeAccess", {
							Email: this.FreeEmail,
							Name: this.FreeName,
							Company: this.FreeCompany
						})
						.then((resp) => {
							if (resp == "User already exists") {
								this.openBadNotification("Please use credentialed user login");
							} else if (resp == "Invalid Username") {
								this.openBadNotification("Your username is not a valid email");
							} else if (resp == "Confirm Email") {
								this.$router.push({
									name: "confirmEmail",
									params: { email: this.FreeEmail.toLowerCase(), code: "freeAccess" }
								});
							} else if (resp != undefined && resp.Exception === undefined) {
								this.$buefy.notification.open({
									duration: 4000,
									message: "Thank you for agreeing to the 'Terms and Conditions'.",
									type: "is-success"
								});
								this.$router.push("/index");
							}
							this.loading = false;
						});
				} else {
					this.$buefy.notification.open({
						duration: 4000,
						message: "You must complete all fields to gain access",
						type: "is-danger"
					});
					this.loading = false;
				}
			},
			login() {
				if (this.CredEmail && this.Password) {
					this.loggingIn = true;
					this.$store
						.dispatch("login", { Email: this.CredEmail, Password: this.Password })
						.then((resp) => {
							if (resp == "Invalid Credentials") {
								this.openBadNotification("The login credentials were invalid.");
							} else if (resp == "You are currently disabled.") {
								this.openBadNotification("You are currently disabled.");
							} else if (resp == "This account has expired.") {
								this.openBadNotification("Your account has expired.");
							} else if (resp == "Invalid Username") {
								this.openBadNotification("Your username is not in email form.");
							} else if (resp != undefined && resp.Exception === undefined) {
								this.$store.getters.bus.$emit("refresh");
								this.$buefy.notification.open({
									duration: 4000,
									message: "Login successful",
									type: "is-success"
								});
								this.$router.push("/index");
							} else if (
								resp.Exception.Message != null &&
								resp.Exception.Message === "Username or Password was incorrect."
							) {
								this.openBadNotification("Your login credentials were invalid.");
							} else if (resp === undefined) {
								this.openBadNotification("An unhandled exception occurred. Please try again later.");
							} else {
								this.openBadNotification(
									"There was an issue contacting the server. Please try again in a few minutes."
								);
							}
							this.loggingIn = false;
						})
						.catch((err) => {
							this.loggingIn = false;
							this.openBadNotification("An unhandled exception occurred. Please try again later.");
						});
				} else {
					this.openBadNotification("You must enter an email and password.");
				}
			},
			openBadNotification(message) {
				this.$buefy.notification.open({
					duration: 4000,
					message: message,
					type: "is-danger"
				});
			}
		},
		mounted() {}
	};
</script>
